export default __webpack_public_path__ + "images/ABB-UI-Icons-24x24-1uwt-.svg";